import {
  LIST_PACKAGE_SERVICE_REQUEST,
  LIST_PACKAGE_SERVICE_SUCCESS,
  LIST_PACKAGE_SERVICE_FAIL,
  LIST_PACKAGE_SERVICE_SUMMARY_REQUEST,
  LIST_PACKAGE_SERVICE_SUMMARY_SUCCESS,
  LIST_PACKAGE_SERVICE_SUMMARY_FAIL,
  SELECT_SERVICE_PACKAGE_SERVICE_REQUEST,
  SELECT_SERVICE_PACKAGE_SERVICE_SUCCESS,
  SELECT_SERVICE_PACKAGE_SERVICE_FAIL,
  SET_PRICE_PACKAGE_SERVICE_REQUEST,
  SET_PRICE_PACKAGE_SERVICE_SUCCESS,
  SET_PRICE_PACKAGE_SERVICE_FAIL,
  DELETE_PACKAGE_SERVICE_REQUEST,
  DELETE_PACKAGE_SERVICE_SUCCESS,
  DELETE_PACKAGE_SERVICE_FAIL,
  RESET_PACKAGE_SERVICE,
  GET_PACKAGE_SERVICE_REQUEST,
  GET_PACKAGE_SERVICE_SUCCESS,
  GET_PACKAGE_SERVICE_FAIL,
  GET_PACKAGE_SERVICE_REQUEST_BY_ID_REQUEST,
  GET_PACKAGE_SERVICE_REQUEST_BY_ID_SUCCESS,
  GET_PACKAGE_SERVICE_REQUEST_BY_ID_FAIL
} from '../../constants/package-services'

const initialState = {
  loading: false,
  packageServices: [],
  packageServiceItems: [],
  packageService: {},
  packageServicesSummary: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const packageServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PACKAGE_SERVICE_REQUEST:
      return { ...state, loading: true }
    case LIST_PACKAGE_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        packageServices: action.payload,
        pageable: action.pageable
      }
    case LIST_PACKAGE_SERVICE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        packageServices: action?.dummy
      }
    case LIST_PACKAGE_SERVICE_SUMMARY_REQUEST:
      return { ...state, loadingSummary: true }
    case LIST_PACKAGE_SERVICE_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingSummary: false,
        packageServicesSummary: action.payload
      }
    case LIST_PACKAGE_SERVICE_SUMMARY_FAIL:
      return { ...state, loadingSummary: false, packageServicesSummary: [], error: action.payload }
    case SELECT_SERVICE_PACKAGE_SERVICE_REQUEST:
      return { ...state, loadingCreate: true }
    case SELECT_SERVICE_PACKAGE_SERVICE_SUCCESS:
      return { ...state, loadingCreate: false }
    case SELECT_SERVICE_PACKAGE_SERVICE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case SET_PRICE_PACKAGE_SERVICE_REQUEST:
      return { ...state, loadingUpdate: true }
    case SET_PRICE_PACKAGE_SERVICE_SUCCESS:
      return { ...state, loadingUpdate: false }
    case SET_PRICE_PACKAGE_SERVICE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case GET_PACKAGE_SERVICE_REQUEST:
      return { ...state, loadingDetail: true }
    case GET_PACKAGE_SERVICE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        packageServiceItems: action.payload
      }
    case GET_PACKAGE_SERVICE_FAIL:
      return {
        ...state,
        loadingDetail: false,
        packageServiceItems: action?.dummy,
        error: action.payload
      }
    case GET_PACKAGE_SERVICE_REQUEST_BY_ID_REQUEST:
      return { ...state, loadingDetail: true }
    case GET_PACKAGE_SERVICE_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        packageServiceItems: action.payload
      }
    case GET_PACKAGE_SERVICE_REQUEST_BY_ID_FAIL:
      return {
        ...state,
        loadingDetail: false,
        packageServiceItems: action?.dummy,
        error: action.payload
      }
    case DELETE_PACKAGE_SERVICE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_PACKAGE_SERVICE_SUCCESS:
      const packageServiceId = action.payload
      const indexServiceCategory = state.packageServices.findIndex(
        (packageService) => packageService.id === packageServiceId
      )
      state.packageServices.splice(indexServiceCategory, 1)

      return { ...state, loadingDelete: false }
    case DELETE_PACKAGE_SERVICE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_PACKAGE_SERVICE:
      return initialState
    default:
      return state
  }
}

export default packageServiceReducer
